/// Tag model API wrapper — endpoints `/api/v1/tag-models/*` (SYS-tag-model).
/// GET is readable by any authenticated user (every screen needs the capability flags);
/// create/update/delete are Super Admin only, enforced server-side.

import { apiClient } from '@/core/api/axios-client'
import type {
  CreateTagModelRequest,
  TagModelSpecResponse,
  UpdateTagModelRequest,
} from '@/types/api'

interface ListResponse {
  items: TagModelSpecResponse[]
}

export const tagModelApi = {
  async list(): Promise<TagModelSpecResponse[]> {
    const res = await apiClient.get<ListResponse>('/tag-models')
    return res.data.items
  },

  async create(payload: CreateTagModelRequest): Promise<TagModelSpecResponse> {
    const res = await apiClient.post<TagModelSpecResponse>('/tag-models', payload)
    return res.data
  },

  /** Identified by the canonical model label — entries of the JSON setting have no id. */
  async update(
    model: string,
    payload: UpdateTagModelRequest,
  ): Promise<TagModelSpecResponse> {
    const res = await apiClient.patch<TagModelSpecResponse>(
      `/tag-models/${encodeURIComponent(model)}`,
      payload,
    )
    return res.data
  },

  async remove(model: string): Promise<void> {
    await apiClient.delete(`/tag-models/${encodeURIComponent(model)}`)
  },
}
